// @flow
// eslint-disable-next-line no-unused-vars
import * as DOMPurify from 'dompurify';
import React from 'react';

function MchCategoryInfoModalContent({ content, hideModal }: { content: any, hideModal: () => void }) {
  return (
    <div className="modal-content box keep-in-touch-done modal-content--stripe mch-category-info-modal-content">
      <div onClick={hideModal} className="mch-category-info-modal-content__closeButton">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <path
            // eslint-disable-next-line max-len
            d="M19.7806 18.2194C19.8503 18.289 19.9056 18.3718 19.9433 18.4628C19.981 18.5539 20.0004 18.6514 20.0004 18.75C20.0004 18.8485 19.981 18.9461 19.9433 19.0372C19.9056 19.1282 19.8503 19.2109 19.7806 19.2806C19.7109 19.3503 19.6282 19.4056 19.5372 19.4433C19.4461 19.481 19.3485 19.5004 19.25 19.5004C19.1514 19.5004 19.0539 19.481 18.9628 19.4433C18.8718 19.4056 18.789 19.3503 18.7194 19.2806L12.5 13.0603L6.28061 19.2806C6.13988 19.4213 5.94901 19.5004 5.74999 19.5004C5.55097 19.5004 5.3601 19.4213 5.21936 19.2806C5.07863 19.1399 4.99957 18.949 4.99957 18.75C4.99957 18.551 5.07863 18.3601 5.21936 18.2194L11.4397 12L5.21936 5.78061C5.07863 5.63988 4.99957 5.44901 4.99957 5.24999C4.99957 5.05097 5.07863 4.8601 5.21936 4.71936C5.3601 4.57863 5.55097 4.49957 5.74999 4.49957C5.94901 4.49957 6.13988 4.57863 6.28061 4.71936L12.5 10.9397L18.7194 4.71936C18.8601 4.57863 19.051 4.49957 19.25 4.49957C19.449 4.49957 19.6399 4.57863 19.7806 4.71936C19.9213 4.8601 20.0004 5.05097 20.0004 5.24999C20.0004 5.44901 19.9213 5.63988 19.7806 5.78061L13.5603 12L19.7806 18.2194Z"
            fill="white"
          />
        </svg>
      </div>

      <div className="mch-category-info-modal-content__container">
        <div className="mch-category-info-modal-content__container--up">
          <div className="mch-category-info-modal-content__title__container">
            <h2 className="mch-category-info-modal-content__title">{content.title}</h2>
            <p
              className="mch-category-info-modal-content__subtitle"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content.subtitle) }}
            />
          </div>

          <ul
            className="mch-category-info-modal-content__list"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content.content) }}
          />
        </div>
      </div>
    </div>
  );
}

export default MchCategoryInfoModalContent;
